import { render, staticRenderFns } from "./FinderTabs.vue?vue&type=template&id=10de4fb2&"
import script from "./FinderTabs.vue?vue&type=script&lang=js&"
export * from "./FinderTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbrown/projects/okinus/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10de4fb2')) {
      api.createRecord('10de4fb2', component.options)
    } else {
      api.reload('10de4fb2', component.options)
    }
    module.hot.accept("./FinderTabs.vue?vue&type=template&id=10de4fb2&", function () {
      api.rerender('10de4fb2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "modules/shop/finder/components/FinderTabs.vue"
export default component.exports